// UTC keeps date-only statement boundaries on the correct day in every timezone.
export const formatStatementPeriod = (start, end, language = 'en') => {
  const formatter = new Intl.DateTimeFormat(language === 'fr' ? 'fr-CA' : 'en-US', {
    month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC',
  });
  const dates = [start, end]
    .filter(Boolean)
    .map((value) => new Date(value))
    .filter((date) => !Number.isNaN(date.getTime()));
  if (!dates.length) return '';
  if (dates.length === 1) return formatter.format(dates[0]);
  // Reuse the locale's shared month/year formatting with the requested regular dash.
  if (dates[0] > dates[1]) return dates.map((date) => formatter.format(date)).join(' - ');
  return formatter.formatRange(dates[0], dates[1]).replace(/\s*[–—]\s*/g, ' - ');
};
